export const GET_SIGNED_URL = 'GET_SIGNED_URL'
export const FETCH_PRE_URL = 'SET_PRE_URL'
export const FETCH_URL_LOCALLY = 'FETCH_URL_LOCALLY'
export const CREATE_JOB_ACTION = 'create-job'
export const CLEAR_UPLOAD = 'CLEAR_UPLOAD'
export const SAVE_PARSING_OPTIONS = 'SAVE_PARSING_OPTIONS'
